import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import {
  Typography,
  TypographyVariants,
} from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import home from "@faire/web-api--source/routes/www/support";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { footerIntro } from "./footerContent";

const useFaireIntroVariant = (): TypographyVariants => {
  const { isTablet, isDesktopAndAbove } = useViewport();
  let introVariant: TypographyVariants = "pageHeaderSerifRegular";
  if (isTablet) {
    introVariant = "pageHeaderSerifRegular";
  } else if (isDesktopAndAbove) {
    introVariant = "displaySSerifRegular";
  }
  return introVariant;
};

export const FaireIntro: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const introVariant = useFaireIntroVariant();
  return (
    <FaireIntroWrapper>
      <Link to={home()}>
        <FaireLogo />
      </Link>
      <Spacer size={12} />
      <IntroParagraph variant={introVariant}>
        {footerIntro(strictLocalize)}
      </IntroParagraph>
    </FaireIntroWrapper>
  );
};

const FaireIntroWrapper = styled.div`
  margin-right: auto;

  ${responsiveMediaQueries.mobile} {
    margin-top: ${getSpacing("2x")};
    padding-bottom: ${getSpacing("2x")};
    margin-bottom: ${getSpacing("2x")};
    border-bottom: 1px solid ${Core.border.muted};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    padding-right: ${getSpacing("2x")};
  }
`;

const IntroParagraph = styled(Typography)`
  &&& {
    ${responsiveMediaQueries.mobile} {
      font-size: 20px;
      margin-top: ${getSpacing("1x")};
    }

    ${responsiveMediaQueries.tabletAndAbove} {
      margin-top: ${getSpacing("2x")};
      max-width: 30ch;
    }
  }
`;
